var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 28.3327C22.3639 28.3327 28.3334 22.3631 28.3334 14.9993C28.3334 7.63555 22.3639 1.66602 15.0001 1.66602C7.63628 1.66602 1.66675 7.63555 1.66675 14.9993C1.66675 22.3631 7.63628 28.3327 15.0001 28.3327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 14.9993L13.0001 18.9993L21.0001 10.9993M28.3334 14.9993C28.3334 22.3631 22.3639 28.3327 15.0001 28.3327C7.63628 28.3327 1.66675 22.3631 1.66675 14.9993C1.66675 7.63555 7.63628 1.66602 15.0001 1.66602C22.3639 1.66602 28.3334 7.63555 28.3334 14.9993Z",
    stroke: "#47AD24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.980a58403cce88fda3731a88847c292a.svg";
export { ForwardRef as ReactComponent };